import React from 'react'
import { useSelector } from 'react-redux'
import AppLoader from './AppLoader'

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255,255,255,0.6)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const GlobalLoader = () => {
  const loadingCounter = useSelector((state) => state.ui.loadingCounter);
  const isExtractionActive = useSelector((state) => state.ui.isExtractionActive);


  if (isExtractionActive) return null;

  if (!loadingCounter) return null;

  return (
    <div style={ overlayStyle }>
      <AppLoader />
    </div>
  );
};

export default GlobalLoader;
